<div>
  <!-- Tabs for large screens -->
  <ul class="nav nav-tabs d-none d-lg-flex" id="myTab" role="tablist">
    @for (tab of licenseTab |keyvalue; track tab) {
    <li
      class="nav-item"
      role="presentation"
      (click)="selectedUser = {};changeTab(tab.value); "
    >
      <a class="nav-link" [ngClass]="{ active: selectedTab === tab.value }"
        >{{ tab.value }}</a
      >
    </li>
    }
  </ul>

  <!-- Dropdown for small screens -->
  <div class="d-block d-lg-none mb-3">
    <div class="form-floating">
      <select
        class="form-select"
        [(ngModel)]="selectedTab"
        (change)="selectedUser = {};changeTab(selectedTab);"
        placeholder="Select"
      >
        @for (tab of licenseTab |keyvalue; track tab) {
        <option [value]="tab.value">{{ tab.value }}</option>
        }
      </select>
      <label for="">Select</label>
    </div>
  </div>

  <div class="tab-content" id="myTabContent">
    @if ( [licenseTab?.tab1,licenseTab?.tab2,
    licenseTab?.tab3].includes(selectedTab)){
    <div
      class="tab-pane"
      [class.active]="[licenseTab?.tab1,licenseTab?.tab2, licenseTab?.tab3].includes(selectedTab)"
    >
      <div class="d-flex align-items-center my-3 gap-2">
        @if (selectedTab === licenseTab?.tab1) {

        <button class="btn btn-primary btn-lg" (click)="addNewLicense()">
          + Add ID
        </button>

        @if (threeMonthCheck) {
        <button
          class="btn btn-outline-danger btn-lg"
          (click)="threeMonthCheck=false; 
            searchParamsGuardIdentifications= {}; 
            initialTotalCount=0;
            showArchived=false; 
            resetPaginationAndCallData(true)"
        >
          Reset
        </button>
        } }
        <div>
          <gtapp-user-lookup
            [selectedUser]="selectedUser"
            (onSelectUserEvent)="onSelectUser($event)"
          ></gtapp-user-lookup>
        </div>
      </div>

      <div>
        @if(initialTotalCount){
        <gtapp-gt-custom-table
          [deskTopTableData]="guardIdentificationDataList"
          [desktopTableDetails]="licenceDetailsDesktopTable"
          [otherParams]="otherParamsGuardIdentifications"
          (paginationChange)="onChangePaginationGuardIdentifications($event)"
          (actionClick)="deleteIdentification($event?.event)"
          (sortColumn)="sortColumnGuardIdentifications($event)"
          (searchColumn)="searchColumnGuardIdentifications($event)"
          (rowClick)="editIdentification($event)"
        ></gtapp-gt-custom-table>
        }@else {
        <div class="alert alert-warning my-4" role="alert">No records yet.</div>
        }
      </div>
    </div>
    }
  </div>
</div>
